import React from 'react';
import { Modal, ListGroup, Spinner, Alert, Form, Button } from '@themesberg/react-bootstrap';
import { formatDateShort } from '../../utils/dateUtils';
import { decodeSpecialCharacters } from '../../utils/textUtils';

const EventAttendeesModal = ({
  show,
  onHide,
  user,
  userEvents,
  loadingEvents,
  selectedEventId,
  onEventSelect,
  eventAttendees,
  loading,
  error
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Usuarios del Evento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <strong>Eventos para: {user?.email}</strong>
        </div>
        
        {loadingEvents && (
          <div className="text-center mb-3">
            <Spinner animation="border" size="sm" className="me-2" />
            Cargando eventos...
          </div>
        )}

        {userEvents.length > 0 && (
          <Form.Group className="mb-3">
            <Form.Label>Seleccionar Evento</Form.Label>
            <Form.Select value={selectedEventId} onChange={onEventSelect}>
              <option value="">Selecciona un evento...</option>
              {userEvents.map((event, index) => (
                <option key={index} value={event.id}>
                  {event.summary || 'Sin título'} - {formatDateShort(event.start?.dateTime || event.start?.date)}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
        
        {loading && (
          <div className="text-center mb-3">
            <Spinner animation="border" size="sm" className="me-2" />
            Obteniendo participantes...
          </div>
        )}

        {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
        
        {!loading && !error && eventAttendees.length > 0 && (
          <div className="mt-3">
            <h6>Participantes del evento:</h6>
            <ListGroup>
              {eventAttendees.map((attendee, index) => (
                <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{decodeSpecialCharacters(attendee.displayName) || attendee.email}</strong>
                    <br />
                    <small className="text-muted">{attendee.email}</small>
                  </div>
                  <span className={`badge fs-6 px-3 py-2 ${
                    attendee.responseStatus === 'accepted' ? 'bg-success' : 
                    attendee.responseStatus === 'declined' ? 'bg-danger' : 
                    attendee.responseStatus === 'tentative' ? 'bg-warning' : 'bg-secondary'
                  }`}>
                    {attendee.responseStatus === 'accepted' ? 'Aceptada' : 
                     attendee.responseStatus === 'declined' ? 'No Aceptada' : 
                     attendee.responseStatus === 'tentative' ? 'Quizás' : 
                     attendee.responseStatus === 'needsAction' ? 'Esperando Respuesta' : 
                     attendee.responseStatus}
                  </span>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        )}
        
        {!loading && !error && eventAttendees.length === 0 && selectedEventId && (
          <Alert variant="info" className="mt-3">No se encontraron participantes para este evento.</Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={onHide}
          style={{
            backgroundColor: '#C5292B',
            borderColor: '#C5292B',
            color: 'white'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#A02225';
            e.target.style.borderColor = '#A02225';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#C5292B';
            e.target.style.borderColor = '#C5292B';
          }}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EventAttendeesModal;